import { useEffect, useState } from 'react';
import { logisticsClient } from '../services/logistics/LogisticsClient';
import { CamasysCustomerResponse } from '../services/logistics/types';

interface State {
  readonly camasysCustomer: CamasysCustomerResponse;
  readonly error: boolean;
  readonly loading: boolean;
}

const initialState: State = {
  camasysCustomer: null,
  error: false,
  loading: true
};

export const useCamasysCustomer = (customerId: number, formVisible: boolean) => {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    setState(initialState);

    logisticsClient
      .getCamasysCustomer(customerId)
      .then((camasysCustomer) => {
        setState({ camasysCustomer, loading: false, error: false });
      })
      .catch((err) => {
        setState({ camasysCustomer: null, loading: false, error: true });
      });
  }, [customerId, formVisible]);

  return state;
};
